import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../utils/checkout';
export function FinalCTA() {
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-53" data-mp="3mtrzkafbyh2x">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-54" data-mp="3mt8qzkbkl51k">
        <h2 className="font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-55" data-mp="3rs38mixswnk3">
          La decisión es tuya.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-gris-texto sm:text-center" data-id="element-56" data-mp="3drsi5h0elazg">
          <p data-id="element-57" data-mp="33uw8h7yrqitb">
            Puedes seguir como hasta ahora. Preparando entrenamientos desde cero cada semana, improvisando
            cuando el plan falla y llegando a la pista con la duda de si lo que vas a hacer es lo correcto
            para tu equipo.
          </p>
          <p data-id="element-58" data-mp="124cbhn7hx6gz">
            O puedes llegar al martes con todo listo. Con la sesión elegida, el objetivo claro y la
            corrección exacta en el bolsillo.
          </p>
          <p className="font-semibold text-marino" data-id="element-59" data-mp="q7c60tyhscb1">Sesiones listas. 6 tomos. 5 bonos. 14 días de garantía.</p>
          <p className="text-naranja" data-id="element-60" data-mp="l90v0fwgnvr8">El precio de una cena. El valor de una temporada entera.</p>
        </div>

        <m.a href={CHECKOUT_URL} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="group mx-auto mt-8 flex max-w-sm flex-col items-center gap-3 rounded-2xl border-2 border-naranja bg-white p-6 text-center shadow-leve transition-colors hover:border-naranja/70" data-id="element-61" data-mp="z05mgupodhqh">
          <span className="font-heading text-sm font-semibold uppercase tracking-wide text-gris-muted" data-id="element-62" data-mp="g833hcpk9pd2">
            🏐 Balonmano Pro 360: La Pizarra del Entrenador
          </span>
          <span className="font-heading text-3xl font-bold text-marino" data-id="element-63" data-mp="1rnrrm7ejwufg">19€</span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-marino px-6 py-3 text-sm font-semibold uppercase text-white transition-colors group-hover:bg-marino-dark" data-id="element-64" data-mp="1mpq85ld7qt3g">
            Quiero Balonmano Pro 360
            <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-65" data-mp="peb02bcqnppj" />
          </span>
          <span className="text-[11px] text-gris-muted" data-id="element-66" data-mp="tbz0ftx7aaot">💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 14 días</span>
        </m.a>
      </div>
    </section>;
}